var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer-coupon-store-num" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            { staticClass: "search-form" },
            [
              _c(
                "el-form",
                {
                  staticClass: "demo-form-inline",
                  attrs: { inline: true, model: _vm.searchForm },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "城市" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择城市", clearable: "" },
                          model: {
                            value: _vm.searchForm.regionId,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "regionId", $$v)
                            },
                            expression: "searchForm.regionId",
                          },
                        },
                        _vm._l(_vm.cityList, function (city) {
                          return _c("el-option", {
                            key: city.regionId,
                            attrs: {
                              label: city.regionName,
                              value: city.regionId,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "门店编码" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入门店编码", clearable: "" },
                        model: {
                          value: _vm.searchForm.storeCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "storeCode", $$v)
                          },
                          expression: "searchForm.storeCode",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "门店名称" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入门店名称", clearable: "" },
                        model: {
                          value: _vm.searchForm.storeName,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "storeName", $$v)
                          },
                          expression: "searchForm.storeName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "客诉券规则名称" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入客诉券规则名称",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.ruleName,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "ruleName", $$v)
                          },
                          expression: "searchForm.ruleName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "生效状态" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择生效状态",
                            clearable: "",
                          },
                          model: {
                            value: _vm.searchForm.effectiveStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "effectiveStatus", $$v)
                            },
                            expression: "searchForm.effectiveStatus",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "生效中", value: "1" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "未生效", value: "2" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "已失效", value: "3" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "发放周期" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100px" },
                          attrs: { placeholder: "请选择周期类型" },
                          model: {
                            value: _vm.issuePeriodType,
                            callback: function ($$v) {
                              _vm.issuePeriodType = $$v
                            },
                            expression: "issuePeriodType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "按月", value: "month" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "按季度", value: "quarter" },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { display: "inline-block" } },
                        [
                          _vm.issuePeriodType === "month" ||
                          !_vm.issuePeriodType
                            ? [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "month",
                                    placeholder: "选择月",
                                    "value-format": "yyyy-MM",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.searchForm.issuePeriod,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.searchForm,
                                        "issuePeriod",
                                        $$v
                                      )
                                    },
                                    expression: "searchForm.issuePeriod",
                                  },
                                }),
                              ]
                            : [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      placeholder: "选择季度",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.searchForm.sendQuarter,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.searchForm,
                                          "sendQuarter",
                                          $$v
                                        )
                                      },
                                      expression: "searchForm.sendQuarter",
                                    },
                                  },
                                  _vm._l(_vm.quarterOptions, function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "创建日期" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          clearable: "",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        on: { change: _vm.handleDateChange },
                        model: {
                          value: _vm.dateRange,
                          callback: function ($$v) {
                            _vm.dateRange = $$v
                          },
                          expression: "dateRange",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSearch },
                        },
                        [_vm._v("查询")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.storeNumList, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", "min-width": "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "ruleName",
                  label: "规则名称",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "storeName",
                  label: "门店名称",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "storeCode",
                  label: "门店编码",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "totalLimit",
                  label: "门店总额度",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(scope.row.totalLimit) +
                            "\n                "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "currentLimit",
                  label: "门店当前额度",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(scope.row.currentLimit) +
                            "\n                "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "usedLimit",
                  label: "门店已使用额度",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(scope.row.usedLimit) +
                            "\n                "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "predictUseLimit",
                  label: "门店预占额度",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(scope.row.predictUseLimit) +
                            "\n                "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "effectiveStatus",
                  label: "生效状态",
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getEffectiveStatusType(
                                scope.row.effectiveStatus
                              ),
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getEffectiveStatusText(
                                  scope.row.effectiveStatus
                                )
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "effectiveLogic",
                  label: "生成周期",
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                scope.row.effectiveLogic == 1
                                  ? "primary"
                                  : "success",
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  scope.row.effectiveLogic == 1
                                    ? "每月"
                                    : "每季度"
                                ) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "issuePeriod",
                  label: "发放周期",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "issueDate",
                  label: "发放日期",
                  "min-width": "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.formatDate(scope.row.issueDate)) +
                            "\n                "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "expireDate",
                  label: "失效时间",
                  "min-width": "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.formatDate(scope.row.expireDate)) +
                            "\n                "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createDate",
                  label: "创建时间",
                  "min-width": "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.formatDate(scope.row.createDate)) +
                            "\n                "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "140",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.handleCouponSendLog(scope.row)
                              },
                            },
                          },
                          [_vm._v("券发放记录")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.searchForm.page,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.searchForm.limit,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.searchForm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "券发放信息",
            visible: _vm.couponSendLogVisible,
            width: "800px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.couponSendLogVisible = $event
            },
            close: function ($event) {
              _vm.couponSendLogVisible = false
            },
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingLog,
                  expression: "loadingLog",
                },
              ],
              attrs: { data: _vm.couponSendLogList, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "issueCode",
                  label: "发放流水号",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "couponId",
                  label: "系统内优惠券ID",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "couponNum",
                  label: "优惠券数量",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "issuedAt",
                  label: "发放时间",
                  "min-width": "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.formatDate(scope.row.issuedAt)) +
                            "\n                "
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dialog-pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.couponInfoLogFrom.page,
                  "page-sizes": [10, 20, 50],
                  "page-size": _vm.couponInfoLogFrom.limit,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.couponInfoLogFrom.total,
                },
                on: {
                  "size-change": _vm.handleLogSizeChange,
                  "current-change": _vm.handleLogCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }